import React from "react";
import { CardHeader } from "reactstrap";
import { useSelector } from "react-redux";

var Utils = require("Utils");
var Const = require("Const");

const getCalendarShortName = (ID, calendars) => {
  let cal = calendars.find((cal) => cal.calendar_id === ID);
  return cal.short_name;
};

const CourseSubjectHeader = ({ courseSubject, coverImage }) => {
  const { calendars } = useSelector((state) => ({
    calendars: state.config.school.calendars,
  }));

  return (
    <CardHeader
      className={"cover-image-card"}
      style={{
        backgroundImage:
          'url("' +
          (courseSubject.cover_image
            ? courseSubject.cover_image
            : coverImage
              ? coverImage
              : Utils.defaultCover()) +
          '")',
      }}
    >
      <div className="float-right h5">
        <i className="fa fa-calendar" />
        {courseSubject.schedule.map((sch, idx) => {
          return (
            (idx > 0 ? " - " : " ") +
            Const.WEEK_DAYS_SHORT[sch.week_day - 1] +
            " de " +
            sch.start_time.slice(0, 5) +
            " a " +
            sch.end_time.slice(0, 5)
          );
        })}
      </div>
      <p className="h2">{Utils.capitalize(courseSubject.subject_name)}</p>
      {courseSubject.calendar_id !== "20260000-5026-4B33-9EAA-000000002026" && (
        <div className="h6" style={{ color: "#ff0000", marginTop: "-10px" }}>
          Este curso corresponde al período{" "}
          {getCalendarShortName(courseSubject.calendar_id, calendars)}
        </div>
      )}
      <p className="curso">
        {Utils.capitalize(courseSubject.course_short_name)} - Turno{" "}
        {courseSubject.shift_name}
      </p>

      <p className="curso"> </p>
    </CardHeader>
  );
};

export { CourseSubjectHeader };
